import React, { useState, useEffect, useCallback } from 'react';
import cn from 'classnames';
import { Spinner } from '@creditflowresearch/uilib/Loader/Spinner';
import Div100vh from '@creditflowresearch/uilib/Layout/Div100vh';
import screenVariables from '@creditflowresearch/uilib/styles/variables/screen.module.scss';
import styles from './modalContent.module.scss';

interface IProps {
  isLoading: boolean,
  footerRef: React.ReactNode,
  children: React.ReactNode,
}

const ModalContent = ({ isLoading, footerRef, children }: IProps) => {
  // @ts-ignore
  const [footerHeight, setFooterHeight] = useState(footerRef?.clientHeight);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleResize = useCallback(() => {
    // @ts-ignore
    footerRef && setFooterHeight(footerRef.clientHeight);
    setWindowWidth(window.innerWidth);
  }, [footerRef]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);

  useEffect(handleResize, [footerRef, children]);

  return (
    <>
      <div
        className={ cn(styles.contentWrp, 'contentWrp') }
        style={
          footerHeight && windowWidth <= parseInt(screenVariables.screenS) ? { paddingBottom: footerHeight } : {}
        }
      >
        { children }
      </div>
      <Spinner
        isVisible={ isLoading }
        overlayClassName={ cn({
          [styles.preloaderSpinnerOverlay]: isLoading,
        }) }
        overlay
      />
      <Div100vh
        className={ cn(styles.modalMobileFooterLayoutWrp, {
          [styles.isVisible]: !!footerHeight && !isLoading,
        }) }
      >
        <div
          className={ styles.modalMobileFooterLayout }
          style={
            footerHeight && windowWidth <= parseInt(screenVariables.screenS) ? { height: footerHeight } : {}
          }
        />
      </Div100vh>
    </>
  );
};

export default ModalContent;
